<template>
    <!-- 筛选 -->
    <div class="selection-sort">
        <Screen
            @close="close"
            @closeAll="closeAll"
            :screenList="screenList"
            :jCheck="jCheck"
        ></Screen>
        <div class="menu_box border_bottom_dashed">
            <!-- 招标信息类型 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.infoTypeShow"
            >
                <div class="title_category">类型</div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': showType }"
                >
                    <span
                        v-for="(item, index) in infoType"
                        :key="index"
                        :class="{ pitch_on: infoTypeShow === index }"
                        @click="change('infoTypeShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showType && infoType.length > 9"
                    @click="showType = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showType && infoType.length > 9"
                    @click="showType = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>

            <div
                class="flex borderBottomDashed paddingAll20"
            >
                <div class="title_category">
                    {{ type.typeLabel ? type.typeLabel : "招标类型" }}
                </div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': !showType }"
                >
                    <span
                        v-for="(item, index) in tenderType"
                        :key="index"
                        :class="{ pitch_on: tenderTypeShow === index }"
                        @click="change('tenderTypeShow', index, item)"
                        v-show="[2,4].includes(+item.no)"
                        >{{ item.name }}</span
                    >
                </div>
                <!--<div-->
                <!--    class="unfold unfold-red flex_ai_center"-->
                <!--    v-if="showType && tenderType.length > 9"-->
                <!--    @click="showType = false"-->
                <!--&gt;-->
                <!--    <span>收起</span>-->
                <!--    <i class="el-icon-arrow-up"></i>-->
                <!--</div>-->
                <!--<div-->
                <!--    class="unfold flex_ai_center"-->
                <!--    v-else-if="!showType && tenderType.length > 9"-->
                <!--    @click="showType = true"-->
                <!--&gt;-->
                <!--    <span>展开</span>-->
                <!--    <i class="el-icon-arrow-down"></i>-->
                <!--</div>-->
            </div>

            <!-- 招标工程类别 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="(
                tenderTypeShow !== 8 &&
                tenderTypeShow !== 20 &&
                tenderTypeShow !== 21 &&
                tenderTypeShow !== 19)"
            >
                <!-- <div class="title_category" v-if="($route.path === '/direct-jb' || type.typeLabel == '竞价类型')">
                    {{ tenderTypeShow | bidOneFilter }}
                </div>
                <div class="title_category" v-else>
                    {{ tenderTypeShow | oneTypeFilter }}
                </div> -->
                <div class="title_category" v-if="tenderTypeShow &&
                    tenderTypeShow !== 8 &&
                    tenderTypeShow !== 20 &&
                    tenderTypeShow !== 21 &&
                    tenderTypeShow !== 19">
                    {{ tenderTypeShow | oneTypeFilter }}

                </div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': showProjeCate }"
                >
                    <span
                        v-for="(item, index) in projeCate"
                        :key="index"
                        :class="{ pitch_on: projeCateShow === index }"
                        @click="change('projeCateShow', index, item)"
                        >{{ item.name || item.categoryName }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showProjeCate && projeCate.length > 12"
                    @click="showProjeCate = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showProjeCate && projeCate.length > 12"
                    @click="showProjeCate = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>

            <!-- 招标工程类别第一级 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="
                    projeCateShow &&
                    projeCate[projeCateShow].children &&
                    projeCate[projeCateShow].children.length
                "
            >
                <!-- <div class="title_category" v-if="($route.path === '/direct-jb' || type.typeLabel == '竞价类型')">
                    {{ bidTwoFilter(tenderTypeShow) }}
                </div>
                <div class="title_category" v-else>
                    {{ tenderTypeShow | twoTypeFilter }}
                </div> -->
                <div class="title_category" v-if="tenderTypeShow &&
                    tenderTypeShow !== 8 &&
                    tenderTypeShow !== 20 &&
                    tenderTypeShow !== 19">
                    {{ tenderTypeShow | twoTypeFilter }}
                </div>
                <!-- <div class="title_category" v-if="(demandFromShow && demandFromShow !== 3 && demandFromShow !== 4) ||
                    (tenderFromShow && tenderFromShow == 4)" >
                    {{ demandFromShow | twoTypeFilters }}
                </div> -->
                <div
                    class="classified_content"
                    :class="{ 'show-type': OneshowProjeCate }"
                >
                    <span
                        v-for="(item, index) in OneprojeCate"
                        :key="index"
                        :class="{ pitch_on: OneprojeCateShow === index }"
                        @click="change('OneprojeCateShow', index, item)"
                        >{{ item.name || item.categoryName }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!OneshowProjeCate && OneprojeCate.length > 12"
                    @click="OneshowProjeCate = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="OneshowProjeCate && OneprojeCate.length > 12"
                    @click="OneshowProjeCate = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <!-- 招标工程类别第二级 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="
                    OneprojeCateShow &&
                    OneprojeCate[OneprojeCateShow].children &&
                    OneprojeCate[OneprojeCateShow].children.length
                "
            >
                <!-- <div class="title_category" v-if="($route.path === '/direct-jb' || type.typeLabel == '竞价类型')">
                    {{ bidThreeFilter(tenderTypeShow) }}
                </div>
                <div class="title_category" v-else>
                    {{ tenderTypeShow | threeTypeFilter }}
                </div> -->
                <div class="title_category">
                    {{ tenderTypeShow | threeTypeFilter }}
                </div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': TwoshowProjeCate }"
                >
                    <span
                        v-for="(item, index) in TwoprojeCate"
                        :key="index"
                        :class="{ pitch_on: TwoprojeCateShow === index }"
                        @click="change('TwoprojeCateShow', index, item)"
                        >{{ item.name || item.categoryName }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!TwoshowProjeCate && TwoprojeCate.length > 12"
                    @click="TwoshowProjeCate = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="TwoshowProjeCate && TwoprojeCate.length > 12"
                    @click="TwoshowProjeCate = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>

            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.engineerTypeShow"
            >
                <div class="title_category">工程类型</div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': showType }"
                >
                    <span
                        v-for="(item, index) in engineerType"
                        :key="index"
                        :class="{ pitch_on: engineerTypeShow === index }"
                        @click="change('engineerTypeShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showType && engineerType.length > 9"
                    @click="showType = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showType && engineerType.length > 9"
                    @click="showType = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="tenderTypeShow == 8"
            >
                <div class="title_category">土地用途</div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': showLandUse }"
                >
                    <span
                        v-for="(item, index) in landUseShowList"
                        :key="index"
                        :class="{ pitch_on: landUseShow === index }"
                        @click="change('landUseShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
            </div>
             <template v-if="tenderTypeShow == 19">
                <div class="flex borderBottomDashed paddingAll20">
                    <div class="title_category">货物类型</div>
                    <div
                        class="classified_content"
                        :class="{ 'show-type': showCargoTypeList }"
                    >
                        <span
                            v-for="(item, index) in cargoTypeList"
                            :key="index"
                            :class="{ pitch_on: cargoTypeListShow === index }"
                            @click="change('cargoTypeListShow', index, item)"
                            >{{ item.name }}</span
                        >
                    </div>
                    <div
                        class="unfold unfold-red flex_ai_center"
                        v-if="!showCargoTypeList && cargoTypeList.length > 12"
                        @click="showCargoTypeList = true"
                    >
                        <span>收起</span>
                        <i class="el-icon-arrow-up"></i>
                    </div>
                    <div
                        class="unfold flex_ai_center"
                        v-else-if="showCargoTypeList && cargoTypeList.length > 12"
                        @click="showCargoTypeList = false"
                    >
                        <span>展开</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </div>
                <div
                    v-if="cargoTypeListShow"
                    class="flex borderBottomDashed paddingAll20"
                >
                    <div class="title_category">要求车型</div>
                    <div
                        class="classified_content"
                        :class="{ 'show-type': showCarTypeByGoodsType }"
                    >
                        <span
                            v-for="(item, index) in carTypeByGoodsTypeList"
                            :key="index"
                            :class="{
                                pitch_on: carTypeByGoodsTypeShow === index,
                            }"
                            @click="
                                change('carTypeByGoodsTypeShow', index, item)
                            "
                            >{{ item.name }}</span
                        >
                    </div>
                    <div
                        class="unfold unfold-red flex_ai_center"
                        v-if="!carTypeByGoodsTypeList && carTypeByGoodsTypeList.length > 12"
                        @click="showCarTypeByGoodsType = true"
                    >
                        <span>收起</span>
                        <i class="el-icon-arrow-up"></i>
                    </div>
                    <div
                        class="unfold flex_ai_center"
                        v-else-if="carTypeByGoodsTypeList && carTypeByGoodsTypeList.length > 12"
                        @click="showCarTypeByGoodsType = false"
                    >
                        <span>展开</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </div>
            </template>
            <!-- 招标形式 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.tenderFromShow"
            >
                <div class="title_category">招标形式</div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': showType }"
                >
                    <span
                        v-for="(item, index) in tenderFrom"
                        :key="index"
                        :class="{ pitch_on: tenderFromShow === index }"
                        @click="change('tenderFromShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <!-- <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showType && tenderType.length > 9"
                    @click="showType = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showType && tenderType.length > 9"
                    @click="showType = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div> -->
            </div>
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.creatTimeShow"
            >
                <div class="title_category">发布时间</div>
                <div
                    class="classified_content"
                    :class="{ 'show-type': showType }"
                >
                    <span
                        v-for="(item, index) in creatTime"
                        :key="index"
                        :class="{ pitch_on: creatTimeShow === index }"
                        @click="change('creatTimeShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showType && creatTime.length > 9"
                    @click="showType = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showType && creatTime.length > 9"
                    @click="showType = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>

            <!-- 招标类型 -->
            <!-- 报名开始时间 -->
            <div class="flex borderBottomDashed paddingAll20" v-if="this.type.timeStartListShow">
                <div class="title_category">{{type.timeLabel?type.timeLabel:'报名开始时间'}}</div>
                <div class="classified_content" :class="{'show-price':showTime}">
                    <span
                        v-for="(item,index) in timeList"
                        :key="index"
                        :class="{'pitch_on':timeListShow === index}"
                        @click="change('timeListShow',index,item)"
                    >{{item.name}}</span>
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showTime && timeList.length>9"
                    @click="showTime = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showTime && timeList.length>9"
                    @click="showTime = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <!-- 报名结束时间 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.timeListShow"
            >
                <div class="title_category">
                    {{ type.timeLabel ? type.timeLabel : "报名结束时间" }}
                </div>
                <div
                    class="classified_content"
                    :class="{ 'show-price': showTime }"
                >
                    <span
                        v-for="(item, index) in timeList"
                        :key="index"
                        :class="{ pitch_on: timeListShow === index }"
                        @click="change('timeListShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showTime && timeList.length > 9"
                    @click="showTime = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showTime && timeList.length > 9"
                    @click="showTime = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>

            <!-- 招标状态 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.tenderStatusShow"
            >
                <div class="title_category">招标状态</div>
                <div
                    class="classified_content"
                    :class="{ 'show-price': showStatus }"
                >
                    <span
                        v-for="(item, index) in tenderStatus"
                        :key="index"
                        :class="{ pitch_on: tenderStatusShow === index }"
                        @click="change('tenderStatusShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showSort && tenderStatus.length > 9"
                    @click="showSort = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showSort && tenderStatus.length > 9"
                    @click="showSort = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <!-- 预算金额 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.priceListShow"
            >
                <div class="title_category">预算金额</div>
                <div
                    class="classified_content"
                    :class="{ 'show-price': showPrice }"
                >
                    <span
                        v-for="(item, index) in priceList"
                        :key="index"
                        :class="{ pitch_on: priceListShow === index }"
                        @click="change('priceListShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showPrice && priceList.length > 9"
                    @click="showPrice = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showPrice && priceList.length > 9"
                    @click="showPrice = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <!-- 中标金额   和预算金额  公用一个 priceListShow-->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.priceWinShow"
            >
                <div class="title_category">中标金额</div>
                <div
                    class="classified_content"
                    :class="{ 'show-price': showPrice }"
                >
                    <span
                        v-for="(item, index) in priceList"
                        :key="index"
                        :class="{ pitch_on: priceListShow === index }"
                        @click="change('priceListShow', index, item)"
                        >{{ item.name }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showPrice && priceList.length > 9"
                    @click="showPrice = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showPrice && priceList.length > 9"
                    @click="showPrice = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>

            <!-- 省份 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.listShow && mapShow"
            >
                <div class="title_category">省份</div>
                <div
                    class="classified_content"
                    :class="{ sort: showArea }"
                    ref="sort"
                >
                    <!--<span @click="reset('categoryList')" :class="{'pitch_on':categoryListAll}">全部</span>-->
                    <span
                        v-for="(item, index) in arealist"
                        :key="index"
                        :class="{ pitch_on: areaShow === index }"
                        @click="change('areaListShow', index, item)"
                        >{{ item.shortName }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showArea && arealist.length > 9"
                    @click="showArea = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showArea && arealist.length > 9"
                    @click="showArea = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
            <!-- 所在地 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="areaShow && mapShow"
            >
                <div class="title_category">所在地</div>
                <div
                    class="classified_content"
                    :class="{ sort: showSort }"
                    ref="sort"
                >
                    <span
                        v-for="(item, index) in citylist"
                        :key="index"
                        :class="{ pitch_on: listShow === index }"
                        @click="change('listShow', index, item)"
                        >{{ item.simpleName }}</span
                    >
                </div>
                <div
                    class="unfold unfold-red flex_ai_center"
                    v-if="!showSort && citylist.length > 9"
                    @click="showSort = true"
                >
                    <span>收起</span>
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div
                    class="unfold flex_ai_center"
                    v-else-if="showSort && citylist.length > 9"
                    @click="showSort = false"
                >
                    <span>展开</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>

            <!-- 更多筛选 -->
            <div
                class="flex borderBottomDashed paddingAll20"
                v-if="this.type.moreShow"
            >
                <div class="title_category">更多筛选</div>
                <div
                    class="classified_content"
                    :class="{ 'show-price': showPrice }"
                >

                    <el-select
                        v-model="endTime"
                        @change="handleTimeType"
                        v-if="this.tenderFromShow === 1"
                        class="select-box"
                        placeholder="请选择报名截止时间"
                    >
                        <el-option
                            v-for="item in timeList"
                            :key="item.no"
                            :value="item.no"
                            :label="item.name"
                        ></el-option>
                    </el-select>

                    <el-select
                        v-model="biddingMethod"
                        class="select-box"
                        @change="handleBiddingMethod"
                        placeholder="请选择招标方式"
                        v-if="tenderFromShow === 1"
                    >
                        <el-option
                            v-for="item in biddingMethodList"
                            :key="item.no"
                            :value="item.no"
                            :label="item.name"
                        ></el-option>
                    </el-select>
                    <el-select
                        v-model="qualificationWay"
                        class="select-box"
                        @change="handleQualificationWay"
                        placeholder="请选择资格审查方式"
                        v-if="tenderFromShow === 1 || tenderFromShow === 3"
                    >
                        <el-option
                            v-for="item in qualificationWayList"
                            :key="item.no"
                            :value="item.no"
                            :label="item.name"
                        ></el-option>
                    </el-select>
                    <el-select
                        v-model="priceListData"
                        class="select-box"
                        @change="handlePriceList"
                        placeholder="请选择预算金额范围"
                        v-if="tenderFromShow === 0 || tenderFromShow === 1 || tenderFromShow === 3"
                    >
                        <el-option
                            v-for="(item, index) in priceList"
                            :key="index"
                            :value="item.no"
                            :label="item.name"
                        ></el-option>
                    </el-select>
                    <el-select
                        v-model="dataSorces"
                        class="select-box"
                        @change="handleDataSource"
                        placeholder="请选择来源"
                        v-if="tenderFromShow === 0"
                    >
                        <el-option
                            v-for="(item, index) in dataSourceList"
                            :key="index"
                            :value="item.no"
                            :label="item.name"
                        ></el-option>
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/http/zhaocai'
import apiMember from '@/api/zhaocai/apiMyMember/apiMember.js'
import cookie from '@/storage/cookies.js'

export default {
  name: 'SelectionSort',
  components: {
    Screen: () => import('./Screen')
  },
  data () {
    return {
      cargoTypeList: [],
      carTypeByGoodsTypeList: [],
      dataSourceList: [],
      dataSorces: '',
      biddingMethodList: [],
      biddingMethod: '',
      qualificationWay: '',
      priceListData: '',
      endTime: '',
      startTimeData: '',
      qualificationWayList: [],
      areaListAll: true,
      fromTypeAll: true,
      screenList: {
        listShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        qualificationWayShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        tenderTypeShow: {
          name: '工程分包',
          index: null,
          no: 4,
          item: {}
        },
        infoTypeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        priceListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        tenderStatusShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        timeListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },

        projeCateShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        areaListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        biddingMethodShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        dataSourceShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        landUseShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        cargoTypeListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        carTypeByGoodsTypeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        engineerTypeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        creatTimeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        tenderFromShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        }
      },
      showSort: true,
      showArea: true,
      showType: true,
      showPrice: true,
      showStatus: true,
      showTime: true,
      showProjeCate: true,
      OneshowProjeCate: true,
      TwoshowProjeCate: true,
      showCargoTypeList: true,
      showCarTypeByGoodsType: true,
      isShowProvince: false,
      isShowSort: false,
      showLandUse: true,
      citylist: [],
      arealist: [],
      tenderType: [],
      engineerType: [], // 工程类型
      creatTime: [], // 发布时间
      infoType: [],
      priceList: [],
      timeList: [],
      tenderStatus: [], // 招标状态
      projeCate: [], // 招标类别
      OneprojeCate: [], // 招标类别
      TwoprojeCate: [], // 招标类别
      landUseShowList: [
        {
          no: 0,
          name: '不限'
        },
        {
          no: '1',
          name: '商业/办公用地'
        },
        {
          no: '2',
          name: '住宅用地'
        },
        {
          no: '3',
          name: '工业用地'
        },
        {
          no: '4',
          name: '农业用地'
        },
        {
          no: '5',
          name: '综合用地'
        },
        {
          no: '6',
          name: '旅游用地'
        },
        {
          no: '7',
          name: '其他用地'
        }
      ],
      showIcon: 8,
      listShow: '',
      areaShow: 0,
      qualificationWayShow: 0,
      biddingMethodShow: 0,
      dataSourceShow: 0,
      tenderTypeShow: 2,
      tenderFromShow: 0,
      demandFromShow: 0,
      engineerTypeShow: 0,
      creatTimeShow: 0,
      infoTypeShow: 0,
      priceListShow: 0,
      timeListShow: 0,
      projeCateShow: 0,
      OneprojeCateShow: 0,
      TwoprojeCateShow: 0,
      tenderStatusShow: 0,
      landUseShow: 0,
      cargoTypeListShow: 0,
      carTypeByGoodsTypeShow: 0,
      jCheck: {},
      moutedType: true,
      projeCateShowVal: null,
      tenderFrom: [],
      demandFrom: [
        { no: 1, name: '材料采购' },
        { no: 2, name: '机械租赁' },
        { no: 3, name: '设备租赁' },
        { no: 4, name: '劳务用工' },
        { no: 5, name: '分包计划' }
      ]
    }
  },
  props: {
    type: {
      type: Object,
      default: function () {
        return {
          listShow: true, // 地区
          tenderTypeShow: true // 招标类型
        }
      }
    },
    mapShow: {
      type: Boolean
    },
    tags: {
      type: [String, Number]
    }
  },
  watch: {
    type: {
      handler: function (n, o) {
        this.initData()
      },
      deep: true,
      immediate: true
    },
    tags: {
      handler: function (n, o) {
        this.tenderFromShow = Number(n)
      },
      deep: true,
      immediate: true
    },

    demandFromShow (val) {
      if (val === 0 || val === 1 || val === 2) {
        let str = ''
        switch (val) {
          case 0:
            str = 'findItemCatAllList'
            break
          case 1:
            str = 'findOnlyMachineryCategoryList'
            break
          case 2:
            str = 'findOnlyEquipmentCategoryList'
            break
        }

        axios.get(`ov1/mechanicalLabor/${str}`).then(data => {
          if (
            data.status === 200 &&
            data.data &&
            data.data.code === 0 &&
            data.data.result &&
            data.data.result.length
          ) {
            this.projeCate = [
              { name: '不限', no: '', children: [] },
              ...data.data.result
            ]
          }
        })
      }
    },
    projeCateShow (val) {
      if (val == '1' || val == '2') {
        this.projeCateShowVal = val
      }
      this.OneprojeCateShow = 0
      if (this.projeCate[val].children) {
        this.OneprojeCate = [
          { name: '不限', no: this.projeCate[val].no, children: [] },
          ...this.projeCate[val].children
        ]
      } else {
        this.OneprojeCate = []
      }
    },
    OneprojeCateShow (val) {
      this.TwoprojeCateShow = 0
      if (this.OneprojeCate[val].children) {
        this.TwoprojeCate = [
          {
            name: '不限',
            no: this.OneprojeCate[val].no,
            children: []
          },
          ...this.OneprojeCate[val].children
        ]
      } else {
        this.TwoprojeCate = []
      }
    },
    areaShow (val) {
      this.listShow = 0
      this.screenList.listShow = {
        name: '',
        index: null,
        no: '',
        item: {}
      }
      if (val) {
        axios
          .get('/old/api/font/citys', {
            areacode: this.arealist[val].id
          })
          .then(res => {
            // this.citylist = res.data.result.list;
            this.citylist = [
              { simpleName: '不限', no: '' },
              ...res.data.result.list
            ]
          })
      } else {
        this.citylist = []
      }
    },
    tenderTypeShow (val) {
      if (val) {
        this.TwoprojeCateShow = 0
        this.OneprojeCateShow = 0
        this.TwoprojeCate = []
        this.OneprojeCate = []


        switch (this.tenderType[val].no) {
          case 11:
          case 15:
            axios
              .get(
                `${
                  process.env.VUE_APP_APIEQUIPMENT
                }/real/category/listCategory?type=0`
              )
              .then(data => {
                if (
                  data.status == 200 &&
                  data.data &&
                  data.data.code == 200 &&
                  data.data.data &&
                  data.data.data.length
                ) {
                  this.projeCate = [
                    { name: '不限', no: '', children: [] },
                    ...data.data.data
                  ]
                }
              })
            break
          case 12:
          case 18:
            axios.get('/ov1/mechanicalLabor/findCarTypeList').then(data => {
              if (
                data.status == 200 &&
                data.data &&
                data.data.code == 0 &&
                data.data.result &&
                data.data.result.length
              ) {
                this.projeCate = [
                  { name: '不限', no: '', children: [] },
                  ...data.data.result
                ]
              }
            })
            break
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 13:
            /* 勘察设计等5个 */
            axios
              .get(`/ov1/tender/type/getTenderType/${val === 7 ? 1 : 2}`)
              .then(data => {
                if (
                  data.status == 200 &&
                  data.data &&
                  data.data.code == 0 &&
                  data.data.result &&
                  data.data.result.length
                ) {
                  this.projeCate = [
                    { name: '不限', no: '', children: [] },
                    ...data.data.result
                  ]
                }
              })
            break
          case 3:
            /* 商品类型--整体 */
            axios.get('/ov1/mechanicalLabor/findItemCatAllList').then(data => {
              if (
                data.status == 200 &&
                data.data &&
                data.data.code == 0 &&
                data.data.result &&
                data.data.result.length
              ) {
                this.projeCate = [
                  { name: '不限', no: '', children: [] },
                  ...data.data.result
                ]
              }
            })
            break
          case 4:
            axios
              .get('/ov1/mechanicalLabor/findTeamCategoryAllList')
              .then(data => {
                if (
                  data.status == 200 &&
                  data.data &&
                  data.data.code == 0 &&
                  data.data.result &&
                  data.data.result.length
                ) {
                  this.projeCate = [
                    { name: '不限', no: '', children: [] },
                    ...data.data.result
                  ]
                }
              })
            break
          case 5:
          case 17:
            axios
              .get('/ov1/mechanicalLabor/findOnlyEquipmentCategoryList')
              .then(data => {
                if (
                  data.status == 200 &&
                  data.data &&
                  data.data.code == 0 &&
                  data.data.result &&
                  data.data.result.length
                ) {
                  this.projeCate = [
                    { name: '不限', no: '', children: [] },
                    ...data.data.result
                  ]
                }
              })
            break
          // /ov1/mechanicalLabor/findMachineryCategoryAllList
          case 1:
          case 16:
            axios
              .get('/ov1/mechanicalLabor/findOnlyMachineryCategoryList')
              .then(data => {
                if (
                  data.status == 200 &&
                  data.data &&
                  data.data.code == 0 &&
                  data.data.result &&
                  data.data.result.length
                ) {
                  this.projeCate = [
                    {
                      name: '不限',
                      no: '',
                      children: []
                    },
                    ...data.data.result
                  ]

                  if (this.$route.query.lease && this.moutedType) {
                    this.projeCateShow = Number(this.$route.query.lease)
                    if (this.$route.query.lease == 1) {
                      this.screenList.projeCateShow.name = '机械'
                      this.screenList.projeCateShow.no = '1'
                    } else {
                      this.screenList.projeCateShow.name = '设备'
                      this.screenList.projeCateShow.no = '2'
                    }
                    this.moutedType = false
                  }
                }
              })

            break
          case 2:
            axios
              .get('/ov1/mechanicalLabor/findTeamCategoryAllList')
              .then(data => {
                if (
                  data.status == 200 &&
                  data.data &&
                  data.data.code == 0 &&
                  data.data.result &&
                  data.data.result.length
                ) {
                  this.projeCate = [
                    { name: '不限', no: '', children: [] },
                    ...data.data.result
                  ]
                }
              })
            break
        }
      } else {
        this.TwoprojeCateShow = 0
        this.OneprojeCateShow = 0
        this.TwoprojeCate = []
        this.OneprojeCate = []
        this.projeCateShow = 0
        this.change('projeCateShow', 0, {
          name: '',
          index: null,
          no: '',
          item: {}
        })
      }
    },
    cargoTypeListShow (val) {
      if (val) {
        apiMember.getCarTypeByGoods(this.cargoTypeList[val].no).then(data => {
          if (
            data.status == 200 &&
            data.data &&
            data.data.code == 200 &&
            data.data.data &&
            data.data.data.length
          ) {
            this.carTypeByGoodsTypeList = [
              { name: '不限', no: '', children: [] },
              ...data.data.data
            ]
          }
        })
      } else {
        this.carTypeByGoodsTypeList = []
      }
    }
  },
  async mounted () {
    this.handleGetTenderForm(0)
    // this.getGoodsTypeList()
    await this.initData()
    this.change('tenderTypeShow',2,{name:'工程分包',no:4})
  },
  methods: {
    handleBiddingMethod (data) {
      this.biddingMethodList.forEach(el => {
        if (el.no === data) {
          this.change('biddingMethodShow', 0, el)
        }
      })
    },
    handleDataSource (data) {
      this.dataSourceList.forEach(el => {
        if (el.no === data) {
          this.change('dataSourceShow', 0, el)
        }
      })
    },
    handleQualificationWay (data) {
      this.qualificationWayList.forEach(el => {
        if (el.no === data) {
          this.change('qualificationWayShow', 0, el)
        }
      })
    },
    handlePriceList (data) {
      this.priceList.forEach(el => {
        if (el.no === data) {
          this.change('priceListShow', 0, el)
        }
      })
    },
    handleTimeType (data) {
      this.timeList.forEach(el => {
        if (el.no === data) {
          this.change('timeListShow', 0, el)
        }
      })
    },

    initData () {
      // 获取工程类型
      axios.get('/ov1/demandNotice/engineeringTypeSelect').then(res => {
        if (res.data.code === 0) {
          let arr = []
          res.data.result.forEach(i => {
            if (i.name === '不限') {
              const { name, no: val } = i
              arr.push({ name, val })
            } else {
              const { name, name: val } = i
              arr.push({ name, val })
            }
          })
          this.engineerType = arr
        }
      })
      // 获取发布时间
      axios.get('/ov1/demandNotice/projectTimeSelect').then(res => {
        if (res.data.code === 0) {
          let arr = []
          res.data.result.forEach(i => {
            const { name, no: val } = i
            arr.push({ name, val })
          })
          this.creatTime = arr
        }
      })
      // 获取信息类型
      axios
        .post('/gv1/information/tender/list', {
          name: '',
          keyword: ''
        })
        .then(res => {
          if (res.data.code === 0) {
            this.infoType = [{ name: '不限', no: '' }, ...res.data.result]
          }
        })
      /* 金额 */
      if (
        (this.type.priceListShow && this.priceList.length <= 0) ||
        this.type.moreShow
      ) {
        axios.get('/ov1/mechanicalLabor/tenderMoneySelect').then(res => {
          if (res.data.code === 0) {
            this.priceList = [
              { name: '不限', no: '-1' },
              ...res.data.result
            ].filter(item => item.name !== '全部')
          }
        })
      }
      // 中标金额
      if (this.type.priceWinShow && this.priceList.length <= 0) {
        axios.get('/ov1/mechanicalLabor/tenderMoneySelect').then(res => {
          if (res.data.code === 0) {
            this.priceList = [
              { name: '不限', no: '' },
              ...res.data.result
            ].filter(item => item.name !== '全部')
          }
        })
      }
      /* 招标状态 */
      if (this.type.tenderStatusShow && this.tenderStatus.length <= 0) {
        axios
          .get('/ov1/mechanicalLabor/tenderBidderSelect')
          // .get("/ov1/mechanicalLabor/tenderEsSelect")
          //   item.name != "再次招标"
          .then(res => {
            if (res.data.code === 0) {
              this.tenderStatus = res.data.result
                .filter(item => item.name !== '即将招标')
                .filter(itt => itt.name !== '招标预告')

              this.tenderStatus = [
                { name: '不限', no: '' },
                ...this.tenderStatus
              ].filter(item => item.name !== '全部')
            }
          })
      }
      // 报名开始/截止时间
      if (this.type.moreShow) {
        axios.get('/ov1/mechanicalLabor/tenderTimeSelect').then(res => {
          if (res.data.code === 0) {
            this.timeList = [
              { name: '不限', no: '0' },
              ...res.data.result
            ].filter(item => item.name !== '全部')
          }
        })
      }
      // 资格审查方式
      if (this.type.moreShow) {
        axios.get('/ov1/mechanicalLabor/tenderTypeBidWaySelect').then(res => {
          if (res.data.code === 0) {
            this.qualificationWayList = [{ name: '不限', no: '0' }, ...res.data.result]
          }
        })
      }
      // // 招标方式
      if (this.type.moreShow) {
        axios.get('/ov1/mechanicalLabor/getBiddingMethod').then(res => {
          if (res.data.code === 0) {
            this.biddingMethodList = res.data.result
          }
        })
      }
      // 数据来源
      if (this.type.moreShow) {
        axios.get('/ov1/mechanicalLabor/getDataSources').then(res => {
          if (res.data.code === 0) {
            this.dataSourceList = res.data.result
          }
        })
      }
      let getTypePath = ''
      // 招标和竞价获取类型的接口不一样
      if (this.type.typeLabel === '竞价类型') {
        getTypePath = '/ov1/bid/getAllBidType'
      } else {
        getTypePath = '/ov1/mechanicalLabor/tenderTypeSelectCustom'
      }
      axios.get(getTypePath).then(res => {
        // this.tenderType = res.data.result.filter(tender=>[2,4].includes(+tender.no))
        this.tenderType = [{name: '不限', no: ''},...res.data.result]
        axios
          .get('/ov1/mechanicalLabor/findTeamCategoryAllList')
          .then(data => {
            if (
              data.status == 200 &&
              data.data &&
              data.data.code == 0 &&
              data.data.result &&
              data.data.result.length
            ) {
              this.projeCate = [
                { name: '不限', no: '', children: [] },
                ...data.data.result
              ]
            }
          })


        // this.change('tenderTypeShow',0,this.tenderType[0])

        // this.tenderType = [{ name: '不限', no: '' }, ...res.data.result]

        this.tenderType.forEach(e => {
          if (e.no == this.$route.query.type) { // 这里因为是query传参，所以只能用双等，不能改成全等
            this.jCheck = e
            // if (this.$route.query.type) {
            //     this.tenderTypeShow = Number(this.$route.query.type);
            // }
            // 商品材料
            if (this.$route.query.type == 3) {
              this.tenderTypeShow = 1
            }
            if (this.$route.query.type == 4) {
              this.tenderTypeShow = 2
            }
            // 劳务分包
            if (this.$route.query.type == 2) {
              this.tenderTypeShow = 3
            }

            if (this.$route.query.type == 1) {
              this.tenderTypeShow = 4
            }
            // 设备租赁
            if (this.$route.query.type == 5) {
              this.tenderTypeShow = 5
            }
            // 工程总包
            if (this.$route.query.type == 10) {
              this.tenderTypeShow = 6
            }
            //  ppp
            if (this.$route.query.type == 13) {
              this.tenderTypeShow = 7
            }

            // 设计规划
            if (this.$route.query.type == 14) {
              this.tenderTypeShow = 8
            }
            // 专业监理
            if (this.$route.query.type == 15) {
              this.tenderTypeShow = 9
            }
            // 地质勘察
            if (this.$route.query.type == 7) {
              this.tenderTypeShow = 10
            }
            // 造价咨询
            if (this.$route.query.type == 8) {
              this.tenderTypeShow = 11
            }
            // 房产租赁
            if (this.$route.query.type == 6) {
              this.tenderTypeShow = 12
            }
            // 车辆租赁
            if (this.$route.query.type == 9) {
              this.tenderTypeShow = 13
            }
            if (this.$route.query.type == 11) {
              this.tenderTypeShow = 14
            }
            if (this.$route.query.type == 12) {
              this.tenderTypeShow = 15
            }

            this.screenList.tenderTypeShow.name = this.jCheck.name
            this.screenList.tenderTypeShow.no = this.jCheck.no
          }
        })
        // if (this.$route.query.type) this.$router.replace({ query: {} })
        // this.tenderType = [
        //   { name: "商品/材料", no: 3 },
        //   { name: "工程分包", no: 4 },
        //   { name: "机械设备租赁", no: 1 },
        //   { name: "劳务", no: 2 }
        // ];
        // 默认选材料
      })
      let areaObj = JSON.parse(cookie.cookieRead('area'))
      if (areaObj.areaName === '北京') {
        this.arealist = [
          { areaName: '全国', id: '', shortName: '全国' },
          ...JSON.parse(localStorage.getItem('areaAll'))
        ]
      } else {
        this.arealist = [
          { areaName: '全国', id: '', shortName: '全国' },
          { ...areaObj },
          ...JSON.parse(localStorage.getItem('areaAll'))
        ]
      }
      this.$emit('aa', {
        screenList: this.screenList,
        tenderType: this.tenderType
      })
    },
    change (name, index, item) {

      if (name === 'listShow') {
        this.$emit('cityChange', item)
        this.listShow = index
        this.screenList.listShow.name = item.simpleName
        this.screenList.listShow.no = item.no
      } else if (name === 'tenderFromShow') {
        // 招标形式
        this.tenderFromShow = index
        this.screenList.tenderFromShow.name = index === 0 ? '' : item.name
        this.screenList.tenderFromShow.no = index === 0 ? '' : item.no
        // 如果index等于0，展示更多筛选，index === 1 招标公告展示 招标方式

        // this.tenderTypeShow = 0
        this.$emit('tenderFromChange', item)

        // 重置需求预告筛选条件
        this.demandFromShow = 0
        this.engineerTypeShow = 0
        this.$emit('engineerChange', { name: '不限', no: '' })
        this.creatTimeShow = 0
        this.$emit('creatTimeChange', { name: '不限', no: '' })
        this.areaShow = 0
        this.$emit('areaChange', { name: '全国', id: '' })
        this.$emit('cityChange', { name: '不限', id: '' })
        this.screenList.engineerTypeShow.name = ''
        this.screenList.engineerTypeShow.no = ''
        this.screenList.creatTimeShow.name = ''
        this.screenList.creatTimeShow.no = ''
        this.screenList.areaListShow.name = ''
        this.screenList.areaListShow.no = ''
        this.screenList.listShow.name = ''
        this.screenList.listShow.no = ''
        // 资格审查方式
        this.screenList.qualificationWayShow.name = ''
        this.screenList.qualificationWayShow.no = ''
        this.screenList.infoTypeShow.name = ''
        this.screenList.infoTypeShow.no = ''
        // 预算金额
        this.screenList.priceListShow.name = ''
        this.screenList.priceListShow.no = ''
        this.screenList.tenderStatusShow.name = ''
        this.screenList.tenderStatusShow.no = ''
        // 截止时间
        this.screenList.timeListShow.name = ''
        this.screenList.timeListShow.no = ''
        // 招标方式
        this.screenList.biddingMethodShow.name = ''
        this.screenList.biddingMethodShow.no = ''
        // 数据来源
        this.screenList.dataSourceShow.name = ''
        this.screenList.dataSourceShow.no = ''
        this.screenList.landUseShow.name = ''
        this.screenList.landUseShow.no = ''
        this.screenList.carTypeByGoodsTypeShow.name = ''
        this.screenList.carTypeByGoodsTypeShow.no = ''
        this.screenList.carTypeByGoodsTypeShow.name = ''
        this.tenderStatusShow = 0
        this.priceListShow = 0
        this.timeListShow = 0
        // 重置更多筛选 所有下拉框
        this.biddingMethod = '' // 招标方式
        this.qualificationWay = '' // 资格审查方式
        this.priceListData = '' // 概算金额
        this.endTime = '' // 截止时间
        this.dataSorces = '' // 数据来源
      } else if (name === 'tenderTypeShow') {
        // query参数type置空
        this.$router.push({ query: {} })
        this.tenderTypeShow = index
        this.screenList.tenderTypeShow.name = item.name
        this.screenList.tenderTypeShow.no = item.no
        if (this.$route.path === '/zb') {
          this.handleGetTenderForm(item.no === '' ? 0 : item.no)
        }
        this.change('projeCateShow', 0, {
          name: '',
          index: null,
          no: '',
          item: {}
        })
        this.$emit('projeCateChange', item)
      } else if (name === 'infoTypeShow') {

        // 点击类型
        this.infoTypeShow = index
        this.screenList.infoTypeShow.name = item.name
        this.screenList.infoTypeShow.no = item.id
      } else if (name === 'priceListShow') {
        this.priceListShow = index
        this.screenList.priceListShow.name = item.name
        this.screenList.priceListShow.no = item.no
      } else if (name === 'timeListShow') {
        this.timeListShow = index
        this.screenList.timeListShow.name = item.name
        this.screenList.timeListShow.no = item.no
      } else if (name === 'tenderStatusShow') {
        // 招标状态
        this.endTime = ''
        this.tenderStatusShow = index
        this.screenList.tenderStatusShow.name = index === 0 ? '' : item.name
        this.screenList.tenderStatusShow.no = index === 0 ? '' : item.no
      } else if (name === 'qualificationWayShow') {
        this.qualificationWayShow = index
        this.screenList.qualificationWayShow.name = item.name
        this.screenList.qualificationWayShow.no = item.no
      } else if (name === 'projeCateShow') {
        this.projeCateShow = index
        this.screenList.projeCateShow.name = item.name || item.categoryName
        this.screenList.projeCateShow.no = item.no || item.id
        this.$emit('projeCateChange', item)
      } else if (name === 'OneprojeCateShow') {
        // 二级分类
        this.OneprojeCateShow = index
        this.screenList.projeCateShow.name = item.name || item.categoryName
        let arr = []
        arr = this.screenList.projeCateShow.no.split(',')
        const nos = `${arr[0]},${item.no || item.id}`
        this.screenList.projeCateShow.no = [...new Set(nos.split(','))].join()
        // this.screenList.projeCateShow.no = `${this.screenList.projeCateShow.no},${item.no || item.id}`
        this.$emit('OneprojeCateChange', item)
      } else if (name === 'TwoprojeCateShow') {
        // 三级分类
        this.TwoprojeCateShow = index
        this.screenList.projeCateShow.name = item.name
        // this.screenList.projeCateShow.no = item.no
        let arr = []
        arr = this.screenList.projeCateShow.no.split(',')
        this.screenList.projeCateShow.no = `${arr[0]},${arr[1]},${item.no || item.id}`
        // this.screenList.projeCateShow.no = `${this.screenList.projeCateShow.no},${item.no || item.id}`
        this.$emit('TwoprojeCateChange', item)
      } else if (name === 'areaListShow') {
        this.$emit('areaChange', item)
        this.areaShow = index
        this.screenList.areaListShow.name = item.shortName
        this.screenList.areaListShow.no = item.id
      } else if (name === 'biddingMethodShow') {
        this.biddingMethodShow = index
        this.screenList.biddingMethodShow.name = item.name
        this.screenList.biddingMethodShow.no = item.no
      } else if (name === 'dataSourceShow') {
        this.dataSourceShow = index
        this.screenList.dataSourceShow.name = item.name
        this.screenList.dataSourceShow.no = item.no
      } else if (name === 'landUseShow') {
        this.landUseShow = index
        // this.screenList.landUseShow.name = item.name
        // this.screenList.landUseShow.no = item.no
        this.screenList.projeCateShow.name = item.name
        this.screenList.projeCateShow.no = item.no
      } else if (name === 'cargoTypeListShow') {
        this.cargoTypeListShow = index
        this.screenList.cargoTypeListShow.name = item.name
        this.screenList.cargoTypeListShow.no = item.no
        this.screenList.projeCateShow.name = item.name || item.categoryName
        this.screenList.projeCateShow.no = item.no || item.id
      } else if (name === 'carTypeByGoodsTypeShow') {
        this.carTypeByGoodsTypeShow = index
        this.screenList.carTypeByGoodsTypeShow.name = item.name
        this.screenList.carTypeByGoodsTypeShow.no = item.no
      } else if (name === 'demandFromShow') {
        this.demandFromShow = index
        this.projeCateShow = 0
        this.screenList.projeCateShow.name = ''
        this.screenList.projeCateShow.no = ''
        this.$emit('demandFormChange', item)
      } else if (name === 'engineerTypeShow') {
        this.engineerTypeShow = index
        this.screenList.engineerTypeShow.name = item.name
        this.screenList.engineerTypeShow.no = item.val
        this.$emit('engineerChange', item)
      } else if (name === 'creatTimeShow') {
        this.creatTimeShow = index
        this.screenList.creatTimeShow.name = item.name
        this.screenList.creatTimeShow.no = item.val
        this.$emit('creatTimeChange', item)
      }
      this.$emit('aa', {
        screenList: this.screenList,
        tenderType: this.tenderType
      })
    },
    close (val, name) {
      if (name === 'listShow') {
        if (this.tenderFromShow == 3) {
          this.change(name, 0, { name: '不限', id: '' })
        } else {
          this.change(name, 0, val.listShow.item)
        }
      } else if (name === 'tenderTypeShow') {
        this.change(name, 0, val.tenderTypeShow.item)
      } else if (name === 'infoTypeShow') {
        this.change(name, 0, val.infoTypeShow.item)
      } else if (name === 'priceListShow') {
        this.change(name, 0, val.priceListShow.item)
      } else if (name === 'tenderStatusShow') {
        this.change(name, 0, val.tenderStatusShow.item)
      } else if (name === 'timeListShow') {
        this.change(name, 0, val.timeListShow.item)
      } else if (name === 'qualificationWayShow') {
        this.change(name, 0, val.qualificationWayShow.item)
      } else if (name === 'projeCateShow') {
        this.change(name, 0, val.projeCateShow.item)
      } else if (name === 'areaListShow') {
        if (this.tenderFromShow == 3) {
          this.change(name, 0, { name: '全国', id: '' })
        } else {
          this.change(name, 0, val.areaListShow.item)
        }
      } else if (name === 'biddingMethodShow') {
        this.change(name, 0, val.biddingMethodShow.item)
      } else if (name === 'dataSourceShow') {
        this.change(name, 0, val.dataSourceShow.item)
      } else if (name === 'landUseShow') {
        this.change(name, 0, val.landUseShow.item)
      } else if (name === 'engineerTypeShow') {
        this.change(name, 0, { name: '不限', val: '' })
      } else if (name === 'creatTimeShow') {
        this.change(name, 0, { name: '不限', val: '' })
      } else {
        this.change(name, 0, val[name].item)
      }
    },
    closeAll () {
      this.screenList = {
        listShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        qualificationWayShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        engineerTypeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        creatTimeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        tenderTypeShow: {
          name: '工程分包',
          index: 2,
          no: 4,
          item: {}
        },
        infoTypeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        priceListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        tenderStatusShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        timeListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },

        projeCateShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        areaListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        biddingMethodShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        dataSourceShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        landUseShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        cargoTypeListShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        carTypeByGoodsTypeShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        },
        tenderFromShow: {
          name: '',
          index: null,
          no: '',
          item: {}
        }
      }
      this.listShow = 0
      this.tenderTypeShow = 2
      this.engineerTypeShow = 0
      this.creatTimeShow = 0
      this.infoTypeShow = 0
      this.priceListShow = 0
      this.tenderStatusShow = 0
      this.timeListShow = 0
      this.qualificationWayShow = 0
      this.biddingMethodShow = 0
      this.dataSourceShow = 0
      this.landUseShow = 0
      this.areaShow = 0
      this.projeCateShow = 0
      this.OneprojeCateShow = 0
      this.TwoprojeCateShow = 0
      this.landUseShow = 0
      this.cargoTypeListShow = 0
      this.carTypeByGoodsTypeShow = 0
      // pc v3.17.1
      this.tenderFromShow = 0
      this.type.tenderStatusShow = false
      this.type.priceListShow = false
      this.type.priceWinShow = false
      this.type.creatTimeShow = false
      // pc3.0  3个下拉框清空
      this.biddingMethod = '' // 招标方式
      this.qualificationWay = '' // 资格审查方式
      this.priceListData = '' // 概算金额
      this.endTime = '' // 截止时间
      this.dataSorces = '' // 数据来源
      this.$emit('aa', {
        clear: 'all', // 用这个字段来判断是否为全部清除
        screenList: this.screenList,
        tenderType: this.tenderType
      })
      this.$emit('getDemandList', { screenList: this.screenList })
    },
    bidTwoFilter (val) {
      switch (val) {
        case 1:
          return '商品类别'
        case 2:
          return '专业分类'
        case 3:
          return '专业分类'
        case 4:
          return `${this.projeCateShowVal == '1' ? '机械' : '设备'}分类`
      }
    },
    bidThreeFilter (val) {
      switch (val) {
        case 1:
          return '商品品名'
        case 2:
          return '业务类型'
        case 3:
          return '业务类型'
        case 4:
          return `${this.projeCateShowVal == '1' ? '机械' : '设备'}类型`
      }
    },
    // 获取货物类型
    async getGoodsTypeList () {
      let res = await apiMember.getGoodsTypeList()
      if (res.data && res.data.code === 200) {
        this.cargoTypeList = [{ name: '不限', no: '' }, ...res.data.data]
      }
    },
    // 通过招标类型获取招标形式
    handleGetTenderForm (no) {
      // pc v3.17.1
      this.tenderFromShow = 0
      this.tenderStatusShow = 0
      this.type.tenderStatusShow = false
      this.type.priceListShow = false
      this.type.priceWinShow = false
      // this.screenList.priceListShow.name = '';
      // this.screenList.priceListShow.no = '';
      // this.screenList.tenderStatusShow.name = ''
      // this.screenList.tenderStatusShow.no = ''
      const _no = this.$route.path === '/zb-gg' ? 20 : no
      this.change('tenderFromShow', 0, { name: '不限', no: 0 })
      axios.get(`/ov1/mechanicalLabor/tenderWayByType/${_no}`).then(res => {
        let result = res.data.result
        this.tenderFrom = [{ name: '不限', no: 0 }, ...result]
      })
    }
  },
  filters: {
    bidOneFilter (val) {
      switch (val) {
        case 1:
          return '商品分类'
        case 2:
          return '工程分类'
        case 3:
          return '工程分类'
        case 4:
          return '租赁类型'
      }
    },
    oneTypeFilters (val) {
      switch (val) {
        case 0:
          return '商品分类'
        case 1:
          return '机械分类'
        case 2:
          return '设备分类'
      }
    },
    oneTypeFilter (val) {
      switch (val) {

        case 1:
          return '商品分类'
        case 4:
        case 16:
          return '机械分类'
        case 5:
        case 17:
          return '设备分类'
        case 2:
        case 3:
        case 6:
        case 7:
        case 8:
        case 13:
        case 10:
        case 11:
        case 12:
          return '工程分类'
        case 9:
        case 14:
          return '房产类型'
        case 12:
        case 15:
        case 18:
          return '车型'
      }
    },
    twoTypeFilters (val) {
      switch (val) {
        case 0:
          return '商品类型'
        case 1:
          return '机械类型'
        case 2:
          return '设备类型'
      }
    },
    twoTypeFilter (val) {
      switch (val) {

        case 1:
          return '商品分类'
        case 4:
        case 16:
          return '机械分类'
        case 5:
        case 17:
          return '设备分类'
        case 2:
        case 3:
        case 6:
        case 7:
        case 8:
        case 13:
        case 10:
        case 11:
        case 12:
          return '工程专项'
        case 9:
        case 14:
          return '房产类型'
        case 15:
        case 18:
          return '车型'
      }
    },
    threeTypeFilter (val) {
      switch (val) {

        case 1:
          return '商品品名'
          break
        case 2:
          return '专业分类'
          break
        case 3:
          return '专业分类'
          break
        case 4:
          return '机械类型'
          break
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.bgff {
  color: #fff;
}
.pipImg {
  position: absolute;
  top: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.selection-sort {
  width: 100%;
  .border_bottom_dashed {
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
  }

  .menu_box {
    width: 1198px;
    margin: 0 auto;
    background: #ffffff;
    position: relative;
    margin-top: 1px;
    // border: 1px solid #e4e7ed;
    .nocheck {
      background: no-repeat url("../../../assets/screen/bg-nocheck.png") left
        top;
    }

    .check {
      background: no-repeat url("../../../assets/screen/bg-check.png") left top;
      z-index: 5;
    }

    .tag-inner {
      width: 155px;
      height: 50px;
      line-height: 50px;
      position: absolute;
      top: -52px;
      text-indent: 30px;
      cursor: pointer;
    }

    .talents {
      right: 260px;
      z-index: 3;
    }

    .construction-team {
      right: 130px;
      z-index: 2;
    }

    .company {
      right: 0;
      z-index: 1;
    }

    .title_category {
      width: 130px;
      text-align: center;
      /*height: 35px;*/
      color: #666666;
      font-weight: 400;
      font-size: 14px;
      /*padding-left: 16px;*/
      background-color: #f5f7fa;
    }

    .province {
      height: 50px;
      overflow: hidden;
    }

    .sort {
      height: 40px;
      overflow: hidden;
    }
    .show-type {
      height: 40px;
      overflow: hidden;
    }
    .show-price {
      height: 40px;
      overflow: hidden;
    }

    .classified_content {
      position: relative;
      flex: 1;
      margin-left: 15px;
      margin-right: 50px;
      //max-height: 50px;
      > span {
        margin-bottom: 5px;
        padding: 0 13px;
        // height: 30px;
        font-size: 14px;
        color: #333;
        display: inline-block;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }

      // .unfold {
      //     position: absolute;
      //     right: 0;
      //     top: 3px;
      //     width: 54px;
      //     height: 35px;
      //     font-size: 12px;
      //     color: #666;
      //     cursor: pointer;
      // }
    }

    .unfold {
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      font-size: 12px;
      color: #666;
      cursor: pointer;
      i {
        margin-left: 5px;
      }
    }
    .unfold-red {
      color: #ff6600;
    }
  }

  .borderBottomDashed {
    border-bottom: 1px dashed #e4e7ed;
  }
  .borderBottomDashed:last-child {
    border-bottom: none;
  }

  .paddingAll20 {
    /*padding: 5px 20px 0;*/
    box-sizing: border-box;
    line-height: 40px;
    position: relative;
  }

  .pitch_on {
    // background: #0286df;
    background: #b79255;
    color: #ffffff !important;
    border-radius: 4px;
  }
  /deep/.select-box {
    padding-right: 20px;
  }
  /deep/.select-box .el-input__inner {
    border-radius: 0;
    width: 180px;
    height: 30px;
  }
}
</style>
